import { TS_AddonEvent } from 'Models/TravelSeller/Models/TS_AddonEvent';
import { ItemType }      from 'Models/UI/ItemType';

export class AddonEvent extends TS_AddonEvent {
    type = ItemType.EVENT;
}